/**
 * @file
 * Home hero background video.
 *
 * Autoplay is skipped for visitors who prefer reduced motion, and a pause/play
 * control is exposed to satisfy WCAG 2.2.2 (Pause, Stop, Hide).
 */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeroVideo(hero) {
    var video = hero.querySelector('.header-page-home--video video');
    var toggle = hero.querySelector('.header-page-home--video-toggle');

    if (!video) {
      return;
    }

    function start() {
      var started = video.play();
      // Autoplay refused: the still image stays and the control takes over.
      if (started && typeof started.catch === 'function') {
        started.catch(function () {});
      }
    }

    function updateToggle() {
      if (!toggle) {
        return;
      }
      var isPlaying = !video.paused;
      toggle.setAttribute('aria-pressed', isPlaying ? 'false' : 'true');
      var label = toggle.getAttribute(isPlaying ? 'data-label-pause' : 'data-label-play');
      var srText = toggle.querySelector('.sr-only');
      if (label && srText) {
        srText.textContent = label;
      }
    }

    video.addEventListener('play', updateToggle);
    video.addEventListener('pause', updateToggle);
    video.addEventListener('playing', function () {
      hero.classList.add('is-video-active');
    });

    if (toggle) {
      toggle.hidden = false;
      updateToggle();
      toggle.addEventListener('click', function () {
        if (video.paused) {
          start();
        }
        else {
          video.pause();
        }
      });
    }

    if (!prefersReducedMotion) {
      start();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document
      .querySelectorAll('.header-page-home.has-hero-video')
      .forEach(function (hero) {
        initHeroVideo(hero);
      });
  });
})();
